import React from 'react';
import './Skeleton.css';

export function SkeletonText({ lines = 3, className = '' }) {
  return (
    <div className={`skeleton-text ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className="skeleton-line"
          style={{
            width: i === lines - 1 ? `${60 + Math.random() * 30}%` : '100%'
          }}
        />
      ))}
    </div>
  );
}

export function SkeletonCard({ className = '' }) {
  return (
    <div className={`skeleton-card ${className}`}>
      <div className="skeleton-card-image" />
      <div className="skeleton-card-content">
        <div className="skeleton-line" style={{ width: '70%' }} />
        <div className="skeleton-line" style={{ width: '90%' }} />
        <div className="skeleton-line" style={{ width: '50%' }} />
      </div>
    </div>
  );
}

export function SkeletonTableRow({ columns = 5, className = '' }) {
  return (
    <div className={`skeleton-table-row ${className}`}>
      {Array.from({ length: columns }).map((_, i) => (
        <div key={i} className="skeleton-cell" style={{ width: `${20 + Math.random() * 15}%` }} />
      ))}
    </div>
  );
}

export function SkeletonAvatar({ size = 40, className = '' }) {
  return <div className={`skeleton-avatar ${className}`} style={{ width: size, height: size }} />;
}

export default function Skeleton({ variant = 'text', count = 1, className = '' }) {
  const skeletons = Array.from({ length: count }).map((_, i) => {
    const key = `skeleton-${i}`;

    switch (variant) {
      case 'text':
        return <SkeletonText key={key} />;
      case 'card':
        return <SkeletonCard key={key} />;
      case 'table-row':
        return <SkeletonTableRow key={key} />;
      case 'avatar':
        return <SkeletonAvatar key={key} />;
      default:
        return <div key={key} className="skeleton" style={{ height: '20px', width: '100%' }} />;
    }
  });

  return <div className={`skeleton-container ${className}`}>{skeletons}</div>;
}
